export default [
  {
    icon: 'mdi-account',
    component: () => import(/* webpackChunkName: "user" */ '@/views/RouterViewComponent.vue'),
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/dashboard';
    },
    name: 'Mis datos de usuario',
    path: '/user',
    redirect: '/user/myaccount',
    meta: {
      requiresAuth: true,
      toolbar: true,
      accountMenu: true,
      tooltip: null,
    },
    children: [
      {
        icon: 'mdi-account',
        component: () => import(/* webpackChunkName: "user" */ './views/MyAccount'),
        name: 'Mis datos de usuario',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/dashboard';
        },
        path: '/user/myaccount',
        meta: {
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        icon: 'mdi-tune',
        component: () => import(/* webpackChunkName: "user" */ './views/MyProfile'),
        name: 'Perfil de negocio',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/dashboard';
        },
        path: '/user/myprofile',
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
    ],
  },
];
